import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { deleteData } from "../../hooks/delete";
import Swal from "sweetalert2";
import useSession from "../../hooks/useSession";
import GlobalForm from "../../components/globalForm/GlobalForm";
import UserTable from "./UserTable";
import UserModal from "./UserModal";
import { Dialog } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function ManageUsersPage() {
  const { userListApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(userListApi);
  const [user] = useSession();
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [submitType, setSubmitType] = useState(""); // value: add | update
  const [activeItemId, setActiveItemId] = useState(); // add | update
  const navigate = useNavigate();

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const newUserData = [
    {
      elementType: "input",
      label: "Full Name",
      type: "Text",
      name: "name",
      fullCol: true,
      required: true,
      // pattern: /^[a-z0-9_.]+$/,
    },
    {
      elementType: "input",
      label: "user",
      type: "text",
      name: "email",
      fullCol: true,
      required: true,
    },
    {
      elementType: "select",
      label: "role",
      type: "Text",
      name: "role",
      required: true,
      fullWidth: true,
      defaultValue: "Select Role",
      options: ["admin", "moderator"],
    },
    {
      elementType: "input",
      label: "new password",
      type: "password",
      name: "password",
      required: true,
      fullCol: true,
      // info: true,
    },
  ];

  const oldUserData = (data) => {
    return [
      {
        elementType: "input",
        label: "Full Name",
        type: "Text",
        name: "name",
        fullCol: true,
        defaultValue: data?.name,
        required: false,
        // pattern: /^[a-z0-9_.]+$/,
      },
      {
        elementType: "input",
        label: "User",
        type: "text",
        name: "email",
        defaultValue: data?.email.split("@")[0],
        fullCol: true,
        required: false,
        disabled: true,
      },
      {
        elementType: "select",
        label: "role",
        type: "Text",
        name: "role",
        defaultValue: data?.role,
        fullCol: true,
        required: false,
        fullWidth: true,
        options: ["admin", "moderator"],
      },
      {
        elementType: "select",
        label: "status",
        type: "Text",
        name: "status",
        defaultValue: data?.status,
        fullCol: true,
        required: false,
        fullWidth: true,
        options: ["active", "inactive"],
      },
      {
        elementType: "input",
        label: "new password",
        type: "password",
        name: "password",
        defaultValue: data?.password,
        required: false,
        fullCol: true,
        // info: true,
      },
    ];
  };

  function handleAddNewUser() {
    setSubmitType("add");
    setModalData(newUserData);
    openModal();
  }

  function handleUserEdit(userData) {
    setActiveItemId(userData._id);
    setSubmitType("update");
    setModalData(oldUserData(userData));
    openModal();
  }

  const refreshPage = () => {
    navigate(0);
  };

  const update = async (data) => {
    if (data.role === "Select Role") {
      toast.warn("Please select a role");
    } else {
      // api call on condition
      if (submitType === "add") {
        const res = await updateData("user/create", data, null, true);
        closeModal();
        res?.length > 0 && refreshPage();
      } else if (submitType === "update") {
        const res = await updateData(
          userListApi,
          data,
          activeItemId,
          null,
          null,
          null,
          true
        );
        closeModal();
        res?.length > 0 && refreshPage();
      }
    }
  };

  // delete single user
  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(userListApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.data._id?.length > 0;
  }

  return (
    <div className="p-4 lg:p-8">
      <h2
        className={`col-span-3 font-semibold text-2xl text-center w-full mb-8 mt-8 `}
      >
        Update Users
      </h2>
      {/* Modal */}
      <UserModal isOpen={isOpen} closeModal={closeModal}>
        <Dialog.Title
          as="h3"
          className="text-2xl text-center font-bold leading-6 text-gray-700 dark:text-darkWhite capitalize mb-4 md:mt-2 md:-mb-4"
        >
          {submitType} User
        </Dialog.Title>
        <GlobalForm data={modalData} update={update} />
      </UserModal>
      {/* add button */}
      <div>
        <button
          onClick={handleAddNewUser}
          className="group fixed bottom-12 md:bottom-20 right-8 md:right-12 bg-secondary hover:px-6 min-w-[3.5rem] md:min-w-[4rem] max-w-[4rem] hover:max-w-[10rem] h-14 md:h-16 rounded-full flex items-center shadow-xl justify-center gap-4 text-white transition-all duration-300 ease-in-out"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5 md:w-8 md:h-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
          {/* <span className="hidden group-hover:block text-lg text-white  transition-all duration-300 ease-in-out">
            ADD
          </span> */}
        </button>
      </div>
      {/* table */}
      {apiData?.length > 0 && (
        <UserTable
          apiData={apiData}
          user={user}
          handleUserEdit={handleUserEdit}
          handleSingleDelete={handleSingleDelete}
        />
      )}
    </div>
  );
}

export default ManageUsersPage;
